export const INIT_SPECIFIC_TEXT_INPUT_ERROR = {
  streetAddress: null,
  city: null,
  postalCode: null,
};

export const ADDRESS_TYPES = [
  { label: "Home", value: "home" },
  { label: "Work", value: "work" },
  { label: "Mailing", value: "mailing" },
  { label: "Investment", value: "investment" },
  { label: "Other", value: "other" },
]
